import * as legacy from "./legacy-analytics";
import * as sendAnalytics4 from "./google-analytics4"

var popup = new Popup();

function Popup() {

    this.sendOpenPhonePopupEvent = function(where, ga4Data) {
        legacy.sendOpenPhonePopupEvent(where);
        sendAnalytics4.sendOpenPopupEvent(ga4Data);
    }

    this.sendOpenContactPopupEvent = function (where, ga4Data) {
        legacy.sendOpenContactPopupEvent(where);
        sendAnalytics4.sendOpenPopupEvent(ga4Data);
    };
}

window.popup = popup;